import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NzI18nModule } from '../i18n/nz-i18n.module';

import { NzDom2ImgNetComponent } from './dom2img-net.component';

@NgModule({
  declarations: [ NzDom2ImgNetComponent ],
  exports     : [ NzDom2ImgNetComponent ],
  imports     : [ CommonModule, NzI18nModule ]
})
export class NzDom2ImgNetModule {
}
